const initialState ={
  restrict_bulk_verify:{},
  poll_search:undefined,
  duplicates_batch_count:undefined,
  companies_batch_count:undefined,
  company_loading:false,
  contacts_loading:false,
  timeline_items_loading:false,
  timeline_items_refresh:0,
  share_success:0,
  refresh:0,
  deleted:[],
  task_data:{},
  current_list:{
    rowsPerPage:(window.innerHeight > 850)?100:20,
    filter:undefined,
    list_id:undefined,
    query:undefined,
    order:undefined,
    total:0,
    ids:[],
    refresh:0,
    in_process:false,
    current_index:0,
    block_iframe:false,
    requested_pages:[]
  }
}


const reducer = (state = initialState, action) => {
  let newState= state;
  switch(action.type){
    case 'SWITCH_WORKSPACE':
      newState=initialState;
      break;
    case 'REQUEST_IFRAME_DATA_SUCCESS':
        if(newState.data[action.id]!=undefined){
          newState.data[action.id].iframe_data=action.iframe_data;
          newState.data[action.id].links=action.links;
          newState.data[action.id].back_links=action.back_links;
          newState.data[action.id].last_scraped=action.last_scraped;
        }
        break;
    case 'REQUEST_AUTOMATED_SEARCH_PREVIEW':
        console.log(action, 'ACTIOOOON GO ON NOW');
        newState.poll_search=true;
        newState.search_name=action.search;
        newState.list_id=action.list_id;
        break;
    case 'REQUEST_AUTOMATED_SEARCH_PREVIEW_SUCCESS':
        newState.poll_search=false;
        newState.company_loading=false;
        if(action.val!='wait'){let ps=[]; let index=0;
          for(let x of action.val){let ct=JSON.parse(x.create_data); ps.push({id:index, main_text:ct.name, secondary_text:"Website: "+ct.website+" - City: "+ct.city, list_id:ct.list_id}); index+=1;}
          newState.search_previews=JSON.parse(JSON.stringify(ps));
          newState.search_batch_id=action.id;
        }
        break;
    case 'REQUEST_AUTOMATED_SEARCH':
        newState.automated_search_completed=false;
        break;
    case 'REQUEST_AUTOMATED_SEARCH_SUCCESS':
        newState.poll_search=false;
        newState.search_previews=undefined;
        newState.block_confirmation=true;
        newState.automated_search_completed=true;
        window.setTimeout(function(){window.updateNotificationRefresh(15000, 600000)},10000);
        break;
    case 'REQUEST_ASSIGN_COMPANIES':
        newState.loading=true;
        break;
    case 'REQUEST_MANAGE_CRM_CONNECTION_SUCCESS':
        window.location.reload();
        break;
    case 'REQUEST_ASSIGN_COMPANIES_SUCCESS':
        window.location.href=window.location.href;
        //for(let id of action.val.company_ids){if(newState.data[id]!=undefined){newState.data[id].user_workspace_id=action.val.user_workspace_id;}}
        break;
    case 'REQUEST_SHARE_COMPANIES_SUCCESS':
        newState.share_success+=1;
    case 'REQUEST_MOVE_COMPANIES':
    case 'REQUEST_SEND_TO_SPECIAL_SERVICE':
        newState.loading=true;
        break;
    case 'REQUEST_COMPANY_UPDATE_MERGE_PROMPT':
        if(newState.data==undefined){newState.data={}}
        if(newState.data[action.val.company_id]!=undefined){newState.data[action.val.company_id].merge_needed=action.val.merge_needed}
        console.log(newState.data[action.val.company_id], action, 'YOO');
        newState.refresh+=1;
        break;
    case 'REQUEST_MOVE_COMPANIES_SUCCESS':
        window.location.href=window.location.href;
        //if(action.val.user_id!=undefined){for(let id of action.val.company_ids){if(newState.data[id]!=undefined){newState.data[id].list_id=action.val.to_list_id; newState.data[id].user_workspace_id=action.val.user_workspace_id;}}}
        //newState.current_list.force_request=true;
        break;
    case 'REQUEST_DELETE_COMPANIES_FAIL':
        newState.company_loading=false;
        newState.loading=false;
        break;
    case 'REQUEST_DELETE_COMPANIES_SUCCESS':
        window.location.reload();
        //for(let c of action.val){delete newState.data[c];}
        //newState.company_loading=false
        //let new_ids=[]; for(let id of newState.current_list.ids){if(!action.val.includes(id)){new_ids.push(id);}}
        //newState.current_list.ids=new_ids;
        //newState.current_list.total=newState.current_list.total - action.val.length;
        break;
    case 'REQUEST_LIST_DELETE':
        newState.loading=true;
        break;
    case 'REQUEST_LIST_MERGE_SUCCESS':
        for(let key in newState.data){if(action.val.merged_lists.includes(newState.data[key].list_id)==true){newState.data[key].list_id=action.val.list.id;}}
        break;
    case 'REQUEST_INDEX_COMPANIES':
        newState.companies_loading=true;
        newState.current_list.in_process=true;
        newState.current_list.force_request=false;
        newState.current_list.requested_pages.push((action.page==undefined)?1:action.page);
        if(action.rowsPerPage!=undefined){newState.current_list.rowsPerPage=action.rowsPerPage;}
        break;
    case 'REQUEST_INDEX_COMPANIES_SUCCESS':
        action=JSON.parse(JSON.stringify(action));
        if(newState.data==undefined){newState.data={}} let type='push';
        if(newState.current_list.start_page==undefined || newState.current_list.start_page==action.val.current_page+1){type='unshift'; newState.current_list.start_page=action.val.current_page}
        if(newState.current_list.end_page==undefined || newState.current_list.end_page==action.val.current_page-1 || newState.current_list.end_page==action.val.current_page){type='push'; newState.current_list.end_page=action.val.current_page}
        //if pages aren't in order this breaks and doesn't work.
        newState.current_list.refresh+=1;
        newState.current_list.in_process=false;
        newState.current_list.last_request=action.val.last_request;
        newState.current_list.filter_id=action.val.filter_id; newState.current_list.filter=action.val.filter; newState.current_list.list_id=action.val.list_id; newState.current_list.query=action.val.query; newState.current_list.order=action.val.order;

        console.log(type, 'TYPE', action.val);
        if(type=='push'){for(let c of action.val.data){c.company_id=c.id; if(c.task_id!=undefined){ c.id=c.task_id; newState.task_data[c.task_id]=c;} if(!newState.current_list.ids.includes(c.id)){newState.current_list.ids.push(c.id);} let old={}; if(newState.data[c.company_id]!=undefined){old=newState.data[c.company_id];} newState.data[c.company_id]={...old, ...c, actual_website:c.website, website:(c.website==null && c.company_listing_websites.length>0)?c.company_listing_websites[0].website:c.website}; if(newState.data[c.company_id].website==undefined){for(let cu of newState.data[c.company_id].company_urls){if(cu.url!=null && cu.url!=undefined && cu.url.includes('facebook.com')){newState.data[c.company_id].website=cu.url;}}}}}
        else if(type=='unshift'){for(let i=action.val.data.length-1; i>=0; i--){let c=action.val.data[i]; c.company_id=c.id; if(c.task_id!=undefined){ c.id=c.task_id; newState.task_data[c.task_id]=c;} if(!newState.current_list.ids.includes(c.id)){newState.current_list.ids.unshift(c.id);} let old={}; if(newState.data[c.company_id]!=undefined){old=newState.data[c.company_id];} newState.data[c.company_id]={...old, ...c, actual_website:c.website, website:(c.website==null && c.company_listing_websites.length>0)?c.company_listing_websites[0].website:c.website}; if(newState.data[c.company_id].website==undefined){for(let cu of newState.data[c.company_id].company_urls){if(cu.url!=null && cu.url!=undefined && cu.url.includes('facebook.com')){newState.data[c.company_id].website=cu.url;}}}}}
        console.log(JSON.parse(JSON.stringify(newState)), 'STRANGE TASK ERROR 1');
        if(action.val.deleted_ids!=undefined){for(let d_id of action.val.deleted_ids){if(newState.data[d_id]!=undefined){delete newState.data[d_id];} if(newState.current_list.ids.includes(d_id)==true){let index = newState.current_list.ids.indexOf(d_id); if(index > -1){newState.current_list.splice(index, 1);} if(index<newState.current_list.current_index){newState.current_list.current_index-=1;}}}}
        if(action.val.updated!=undefined){for(let u of action.val.updated){newState=checkAndInsertUC(newState, u);}}
        if(action.val.created!=undefined){for(let c of action.val.created){newState=checkAndInsertUC(newState, c);}}
        newState.current_list.total=(action.val.total==0)?'empty':action.val.total;
        newState.current_list.block_iframe=false;
        newState.company_loading=false;
        console.log(newState, 'STRANGE TASK ERROR');
        break;
    case 'REQUEST_INDEX_COMPANIES_MODIFY':
        newState.current_list={...newState.current_list, ...action.val, refresh:newState.current_list.refresh+1}
        break;
    case 'REQUEST_LIST_MERGE_SUCCESS':
    case 'RESET_CURRENT_LIST':
        let info=action.info; if(info==undefined){info={}}
        newState.current_list={...newState.current_list, last_request:undefined, block_iframe:true, total:0, current_index:0, requested_pages:[], ids:[], start_page:undefined, end_page:undefined, refresh:newState.current_list.refresh+1, ...info}
        break;
    case 'REQUEST_LIST_GET_C_SUCCESS':
    case 'REQUEST_LIST_CREATE_C_SUCCESS':
    case 'REQUEST_LIST_UPDATE_C_SUCCESS':
        if(newState.data==undefined){newState.data={}}
        if(action.val.companies!=undefined){for(let company of action.val.companies){let old={}; if(newState.data[company.id]!=undefined){old=newState.data[company.id];} newState.data[company.id]={...old, ...company, company_fields:(company.updated_company_fields==undefined)?(company.company_fields==undefined)?old.company_fields:company.company_fields:company.updated_company_fields}}}
        break;
    case 'REQUEST_COMPANY_DELETE_SUCCESS':
        //if(newState.deleted.includes(action.val.id)!=true){newState.deleted.push(action.val.id);}
        let new_n=Number(window.location.href.split('/view/')[1].split('/')[0]);
        if(new_n>1){new_n=new_n-1;}
        console.log('YOOOOO');
        window.location.href=window.location.href.split('/view/')[0]+'/view/'+new_n+window.location.href.split('/view/')[1].split('/')[1];
        break;
    case 'REQUEST_COMPANY_GET_SUCCESS':
    case 'REQUEST_COMPANY_UPDATE_SUCCESS':
    case 'REQUEST_COMPANY_CREATE_SUCCESS':
        if(newState.data==undefined){newState.data={}}
        let new_company={...action.val, actual_website:action.val.website, website:(action.val.website==null && action.val.company_listing_websites.length>0)?action.val.company_listing_websites[0].website:action.val.website, company_fields:(action.val.updated_company_fields==undefined)?action.val.company_fields:action.val.updated_company_fields}; if(newState.data[action.val.id]!=undefined){new_company={...newState.data[action.val.id], ...new_company}}
        newState.data[action.val.id]=new_company
        if(action.type=='REQUEST_COMPANY_CREATE_SUCCESS'){newState.current_list={...newState.current_list, last_request:undefined, block_iframe:true, total:0, current_index:0, requested_pages:[], ids:[], start_page:undefined, end_page:undefined, refresh:newState.current_list.refresh+1, force_request:true}}
        newState.company_loading=false;
        newState.refresh+=1;
      break;
    case 'REQUEST_EDIT_FIELD_COMPANIES':
      newState.loading=true;
      break;
    case 'REQUEST_EDIT_FIELD_COMPANIES_SUCCESS':
        window.location.reload();
        newState.refresh+=1;
      break;
    case 'REQUEST_CONTACTS_INDEX_SUCCESS':
        if(newState.data==undefined){newState.data={}} if(newState.data[action.val.id]==undefined){newState.data[action.val.id]={contacts:[]}}
        newState.data[action.val.id].contacts=action.val.contacts;
        newState.contacts_loading=false;
        newState.refresh+=1;
    break;
    case 'REQUEST_CONTACT_DELETE_SUCCESS':
        let nc=[]; if(newState.data[action.val.company_id].contacts!=undefined){for(let c of newState.data[action.val.company_id].contacts){if(c.id!=action.val.id){if(c.id==action.val.new_main){nc.push({...c, pivot:{...c.pivot, main_contact:true}});}else{nc.push(c);}}}}
        let nt=[]; if(newState.data[action.val.company_id].timeline_items!=undefined){for(let t of newState.data[action.val.company_id].timeline_items){if(t.contact_id!=action.val.id){nt.push(t);}}}
        newState.data[action.val.company_id].contacts=nc;
        newState.data[action.val.company_id].timeline_items=nt;
        newState.contacts_loading=false;
        newState.refresh+=1;
      break;
    case 'REQUEST_CONTACT_MERGE_SUCCESS':
    case 'REQUEST_VERIFY_NOW_SUCCESS':
    case 'REQUEST_GET_PHONE_NUMBER_NOW_SUCCESS':
    case 'REQUEST_GET_EMAIL_NOW_SUCCESS':
    case 'REQUEST_CONTACT_CREATE_SUCCESS':
    case 'REQUEST_CONTACT_UPDATE_SUCCESS':
        newState.loading=false;
        if(newState.data==undefined){newState.data={}} if(newState.data[action.val.pivot.company_id]==undefined){newState.data[action.val.pivot.company_id]={contacts:[]}}
        let new_contacts=[]; let contact_done=false; for(let contact of newState.data[action.val.pivot.company_id].contacts){let c=contact; if(contact.id==action.val.id){contact_done=true; c={...c, ...action.val, pivot:{...c.pivot, ...action.val.pivot}}}else if(contact.pivot.main_contact==true && action.val.pivot.main_contact==true){c.pivot.main_contact=false} if(c.id!=action.val.old_contact_id){if(c.pivot.main_contact==true){new_contacts.unshift(c);}else{new_contacts.push(c);}}} if(contact_done==false){if(action.val.pivot.main_contact==true){new_contacts.unshift(action.val);}else{new_contacts.push(action.val);}}
        newState.data[action.val.pivot.company_id].contacts=new_contacts;
        if(action.val.old_company_id!=undefined){
          //Except for last line and "old_company_id" this is word for word delete contact
          let nc=[]; if(newState.data[action.val.old_company_id].contacts!=undefined){for(let c of newState.data[action.val.old_company_id].contacts){if(c.id!=action.val.id){if(c.id==action.val.new_main){nc.push({...c, main:true});}else{nc.push(c);}}}}
          let nt=[]; if(newState.data[action.val.old_company_id].timeline_items!=undefined){for(let t of newState.data[action.val.old_company_id].timeline_items){if(t.contact_id!=action.val.id){nt.push(t);}}}
          newState.data[action.val.old_company_id].contacts=nc;
          newState.data[action.val.old_company_id].timeline_items=nt;
          newState.data[action.val.company_id].timeline_items=undefined;
        }
        newState.refresh+=1;
        newState.contacts_loading=false;
      break;
    case 'REQUEST_UPDATE_CONTACT_COMPANY_RELATIONS_SUCCESS':
      for(let cc of action.val.company_contacts){let nc=newState.data[cc.company_id];
        if(nc!=undefined){let new_contacts=[]; for(let c of nc.contacts){if(cc.contact_id!=c.id){new_contacts.push(c);}} if(cc.connected){new_contacts.push(newState.contact);} newState.data[cc.company_id].contacts=new_contacts;}
      }
      newState.refresh+=1;
      newState.contacts_loading=false;
      break;
    case 'REQUEST_AUTHORIZE_GMAIL_CONTACT_SUCCESS':
    case 'REQUEST_TIMELINE_ITEMS_GET_SUCCESS':
        if(newState.data==undefined){newState.data={}} if(newState.data[action.company_id]==undefined){newState.data[action.company_id]={}}
        newState.data[action.company_id].timeline_items=[]; for(let key in action.val){newState.data[action.company_id].timeline_items.push(action.val[key]);}
        newState.timeline_items_loading=false;
        newState.timeline_items_refresh+=1;
      break;
    case 'REQUEST_BULK_DELETE_TIMELINE_ITEMS_SUCCESS':
      window.location.href=window.location.href;
      break;
    case 'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS':
        let new_t_items=[]; for(let t of newState.data[action.val.company_id].timeline_items){if(t.id!=action.val.id){new_t_items.push(t);}}
        newState.data[action.val.company_id].timeline_items=new_t_items;
        newState.timeline_items_loading=false;
        newState.timeline_items_refresh+=1;
        console.log(newState, 'DELETED TIMELINE');
      break;
    case 'REQUEST_TIMELINE_ITEM_UPDATE_READ_SUCCESS':
         let nnn=[];
         for(let ti of newState.data[action.val.timeline_item.company_id].timeline_items){
           if(ti.id==action.val.timeline_item.id){
             ti.email_message.read=action.val.timeline_item.email_message.read;
           }
           nnn.push(ti);
         }
         newState.data[action.val.timeline_item.company_id].timeline_items=nnn;
         newState.timeline_items_loading=false;
         newState.timeline_items_refresh+=1;
      break;
    case 'REQUEST_COMPLETE_TASK_SUCCESS':
    case 'REQUEST_TIMELINE_ITEM_CREATE_SUCCESS':
    case 'REQUEST_TIMELINE_ITEM_UPDATE_SUCCESS':
    case 'REQUEST_CANCEL_EMAIL_NOW_SUCCESS':
    case 'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS':
        let tis=action.val.timeline_items; if(action.type=='REQUEST_TIMELINE_ITEM_UPDATE_SUCCESS'){tis=[action.val.timeline_item];}
        if(tis==undefined){tis=[];}
        if(action.val.completed_task!=undefined && action.val.completed_task!=null){
          tis.push(action.val.completed_task);
        }

        console.log('TIM IT', tis, action);
        for(let timeline_item of tis){
          if(timeline_item.company_id==undefined){timeline_item.company_id=action.val.company_id;}
          if(newState.data==undefined){newState.data={}} if(newState.data[timeline_item.company_id]==undefined){newState.data[timeline_item.company_id]={timeline_items:[]}}
          let new_timeline_items=[]; let timeline_done=false; for(let ti of newState.data[timeline_item.company_id].timeline_items){if(ti.id==timeline_item.id){new_timeline_items.push(timeline_item); timeline_done=true;}else{new_timeline_items.push(ti);}} if(timeline_done==false){new_timeline_items.unshift(timeline_item);}
          newState.data[timeline_item.company_id].timeline_items=new_timeline_items;
          if(action.val.status!=undefined){newState.data[timeline_item.company_id].status=action.val.status;}
          let nnn=[]; for(let ti of newState.data[timeline_item.company_id].timeline_items){if(action.val.delete_timeline_item_id==ti.id){}else if(ti.type==2 && ti.sub_type==1){nnn.unshift(ti);}else{nnn.push(ti);}}
          let nnnn=[]; for(let n of nnn){if(n.type==2 && n.sub_type==2){console.log('UNSHIFT', n); nnnn.unshift(n)}else{nnnn.push(n)}} nnn=nnnn
          newState.data[timeline_item.company_id].timeline_items=nnn;
        }
        newState.timeline_items_refresh+=1;
        newState.timeline_items_loading=false;
        newState.follow_up_type=action.val.follow_up_type;
        if(action.val.open_popup!=undefined){
          console.log('OPEN POPUP', action.val.open_popup);
          window.open(action.val.open_popup, 'send_message_popup', 'height=' + window.outerHeight + ', width=' + window.screenX + ', top=' + window.screenY + ', left=0');
        }
      break;
    case 'REQUEST_FOLLOW_UP_TYPE_DONE':
        newState.follow_up_type=undefined;
      break;
    case 'REQUEST_LOADER_NOW':
        newState.loading=action.val;
      break;
    case 'REQUEST_DELETE_COMPANIES':
        newState.loading=true;
    case 'REQUEST_COMPANY_UPDATE':
    case 'REQUEST_COMPANY_CREATE':
    case 'REQUEST_COMPANY_GET':
        newState.company_loading=true
      break;
    case 'REQUEST_CONTACT_MERGE':
    case 'REQUEST_CONTACT_UPDATE':
    case 'REQUEST_CONTACT_CREATE':
    case 'REQUEST_CONTACT_DELETE':
    case 'REQUEST_LOAD_CONTACTS':
    case 'REQUEST_CONTACT_LOAD':
    case 'REQUEST_UPDATE_CONTACT_COMPANY_RELATIONS':
        newState.contacts_loading=true
      break;
    case 'REQUEST_CONTACT_FAIL':
        newState.contacts_loading=false;
      break;
    case 'REQUEST_AUTHORIZE_GMAIL_CONTACT':
    case 'REQUEST_TIMELINE_ITEMS_GET':
    case 'REQUEST_TIMELINE_ITEM_UPDATE':
    case 'REQUEST_TIMELINE_ITEM_CREATE':
    case 'REQUEST_TIMELINE_ITEM_DELETE':
    case 'REQUEST_COMPLETE_TASK':
    case 'REQUEST_CREATE_CALL_MANAGER_FOLLOW_UP_TASK':
    case 'REQUEST_CLICK_SALES_COACH_CHECKLIST':
        newState.timeline_items_loading=true
      break;
    case 'GMAIL_UNAUTHORISED':
    case 'REQUEST_CLICK_SALES_COACH_CHECKLIST_FAIL':
        newState.timeline_items_loading=false;
      break;
    case 'REQUEST_DELETE_WORKSPACE_FIELD_SUCCESS':
    case 'REQUEST_DELETE_WORKSPACE_DECISION':
    case 'REQUEST_MERGE_WORKSPACE_FIELDS':
    case 'REQUEST_MERGE_WORKSPACE_DECISIONS':
        newState.data=undefined;
      break;
    case 'REQUEST_READ_EMAIL_MESSAGE_SUCCESS':
      for(let t of newState.data[action.val.company_id].timeline_items){if(t.email_message!=undefined && t.email_message.gmail_id==action.val.gmail_id){t.read=true;}}
      break;
    case 'REQUEST_SEND_EMAIL_NOW_SUCCESS':
      let nn=[]; for(let t of newState.data[action.val.timeline_item.company_id].timeline_items){if(t.id==action.val.timeline_item.id){nn.push(action.val.timeline_item);}else{nn.push(t);}}
      break;
    case 'REQUEST_COMPANY_CREATE_BATCH':
      newState.loading=true;
      break;
    case 'REQUEST_COMPANY_CREATE_BATCH_SUCCESS':
      console.log('BATCH SUCCESS', action)
      newState.uploaded_prospect_batch_id=action.val.prospect_batch_id;
      newState.duplicates_batch_count=undefined;
      newState.companies_batch_count=action.val.companies_count;
      newState.duplicates=[];
      newState.loading=false;
      newState.refresh+=1;
      console.log(newState);
      break;
    case 'REQUEST_UPDATE_BATCH_DUPLICATES_SUCCESS':
       newState.duplicates=undefined;
       newState.duplicates_batch_count=undefined;
       newState.uploaded_prospect_batch_id=undefined;
       break;
    case 'RESET_CSV_DATA':
        newState.duplicates=undefined;
        newState.duplicates_batch_count=undefined;
        newState.companies_batch_count=undefined;
        newState.uploaded_prospect_batch_id=undefined;
        break;
    case 'RESTRICT_BULK_VERIFY':
        newState.restrict_bulk_verify[action.company_id]=action.val;
        break;
    case 'REMOVE_LOADING':
      newState.loading=false;
      newState.timeline_items_loading=false;
      newState.company_loading=true
      newState.contacts_loading=true
      break;
    }
  return newState;
}



function checkAndInsertUC(newState, company){
  let o=newState.data[company.id];
  if(o==undefined){o={}}
  newState.data[company.id]={...o, ...company};
  //When you add ordering, this must change.
  if(newState.current_list.ids.includes(company.id)==false && newState.current_list.ids[newState.current_list.ids.length - 1]>company.id){
    for(let i=newState.current_list.ids.length-2; i>=0; i--){if(newState.current_list.ids[i]<company.id){newState.current_list=newState.current_list.splice(i,0, company.id); if(newState.current_list.current_index>i){newState.current_list.current_index+=1;} break;}}
  }
  return newState;
}

export default reducer;
